"use client";

import {
	RiAndroidFill,
	RiAppleFill,
	RiInstagramFill,
	RiTiktokFill,
} from "@remixicon/react";
import Link from "next/link";
import { memo } from "react";
import { CCPAFooter } from "@/components/analytics/ccpa-footer";
import { cn } from "@/lib/utils";

const SOCIAL_LINKS = {
	instagram: "https://www.instagram.com/humblefestivals/",
	tiktok: "https://www.tiktok.com/@humblefestivals",
	ios: "https://apps.apple.com/us/app/humble-festivals-with-friends/id6749406367",
	android: "https://play.google.com/store/apps/details?id=com.humbleos.mobile&hl=en_US",
};

interface LegalFooterProps {
	className?: string;
	variant?: "default" | "minimal";
	showCCPA?: boolean;
}

export const LegalFooter = memo(function LegalFooter({
	className,
	variant = "default",
	showCCPA = true,
}: LegalFooterProps) {
	if (variant === "minimal") {
		return (
			<div
				className={cn(
					"flex items-center justify-center gap-3 text-muted-foreground text-xs",
					className,
				)}
			>
				<Link
					href={SOCIAL_LINKS.instagram}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="Instagram"
				>
					<RiInstagramFill className="h-4 w-4" />
				</Link>
				<Link
					href={SOCIAL_LINKS.tiktok}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="TikTok"
				>
					<RiTiktokFill className="h-4 w-4" />
				</Link>
				<Link
					href={SOCIAL_LINKS.ios}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="iOS App"
				>
					<RiAppleFill className="h-4 w-4" />
				</Link>
				<Link
					href={SOCIAL_LINKS.android}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="Android App"
				>
					<RiAndroidFill className="h-4 w-4" />
				</Link>
				<span>|</span>
				<Link href="/support" className="hover:text-primary">
					Support
				</Link>
				<span>•</span>
				<Link href="/legal/terms" className="hover:text-primary">
					Terms
				</Link>
				<span>•</span>
				<Link href="/legal/privacy" className="hover:text-primary">
					Privacy
				</Link>
			</div>
		);
	}

	return (
		<div className={cn("space-y-2", className)}>
			<div className="flex items-center justify-center gap-3 text-muted-foreground text-xs">
				<Link
					href={SOCIAL_LINKS.instagram}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="Instagram"
				>
					<RiInstagramFill className="h-4 w-4" />
				</Link>
				<Link
					href={SOCIAL_LINKS.tiktok}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="TikTok"
				>
					<RiTiktokFill className="h-4 w-4" />
				</Link>
				<Link
					href={SOCIAL_LINKS.ios}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="iOS App"
				>
					<RiAppleFill className="h-4 w-4" />
				</Link>
				<Link
					href={SOCIAL_LINKS.android}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-primary"
					aria-label="Android App"
				>
					<RiAndroidFill className="h-4 w-4" />
				</Link>
			</div>
			<div className="text-center text-muted-foreground text-xs">
				<Link href="/support" className="hover:text-primary">
					Support
				</Link>
				{" • "}
				<Link href="/legal/terms" className="hover:text-primary">
					Terms
				</Link>
				{" • "}
				<Link href="/legal/privacy" className="hover:text-primary">
					Privacy
				</Link>
			</div>
			{showCCPA && <CCPAFooter />}
		</div>
	);
});
